"use client";
import React from "react";
import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react";
import { useTheme } from "next-themes";
import { Toaster as Sonner, type ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      // z-[9999] ensures toasts appear above all modals/dialogs (which use z-50)
      // pointer-events-auto ensures clicks register on toast buttons
      className="toaster group !z-[9999] !pointer-events-auto"
      position="bottom-center"
      // Ensure consistent stacking direction across platforms (newest on top)
      dir="ltr"
      // Invert puts newest toast on top of the stack
      invert
      // Increase gap between stacked toasts for better visual separation
      gap={16}
      toastOptions={{
        className: "!z-[9999] !pointer-events-auto",
        style: { pointerEvents: "auto" },
      }}
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={
        {
          // "--normal-bg": "var(--popover)",
          // "--normal-text": "var(--popover-foreground)",
          // "--normal-border": "var(--border)",
          // "--border-radius": "var(--radius)",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
